var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_3247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1C50.6731 1 65 15.3269 65 33C65 50.6731 50.6731 65 33 65C15.3269 65 1 50.6731 1 33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1642 44C47.1642 44 44.0936 45.2054 45.2674 46.5996C46.4412 47.9937 49 45.2998 49 45.2998L47.1642 44Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0535 18.9196C40.984 18.6625 40.9822 18.3913 41.0482 18.1332C41.1141 17.8752 41.2456 17.6395 41.4293 17.4499C41.6129 17.2603 41.8423 17.1236 42.0943 17.0534C42.3463 16.9833 42.6119 16.9822 42.8644 17.0503C47.5909 18.3693 51.7431 21.2786 54.6485 25.3073C55.1654 26.0234 55.6593 26.7226 56.1236 27.3984C57.6676 29.6422 58.2943 32.4121 57.8708 35.12C57.4472 37.8279 56.0067 40.2607 53.855 41.9018L48.4914 46L46.371 44.0198L50.6744 39.8208C51.226 39.2824 51.6647 38.6352 51.9638 37.9183C52.2629 37.2015 52.4162 36.4301 52.4143 35.651C52.4125 34.8718 52.2556 34.1012 51.953 33.3859C51.6505 32.6706 51.2088 32.0255 50.6546 31.4899L42.2059 23.3304L41.0535 18.9196Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0347 11.6904C36.4732 12.4499 36.7949 13.2588 36.9908 14.0952C37.0074 14.1956 37.0015 14.2979 36.9735 14.3962C36.9456 14.4945 36.896 14.5869 36.8277 14.668C36.7595 14.7491 36.6739 14.8173 36.5759 14.8686C36.4779 14.9199 36.3695 14.9534 36.2569 14.967C35.8971 15.0311 35.5242 15.0014 35.1828 14.8815C34.8413 14.7616 34.5457 14.5565 34.3313 14.2906L33.2843 13.2205C33.0993 12.9877 33 12.7093 33 12.4239C33 12.1385 33.0993 11.8601 33.2843 11.6273C33.9172 10.7255 35.6004 10.8397 36.0347 11.6904Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5406 13L33.3 18L36.3 17.9251L35.2697 14.3174L33.5406 13Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 13.4178C35 13.4178 34.7063 12.8217 34.2131 13.0535C33.7198 13.2853 34.1415 14.1497 34.8795 13.9775L35 13.4178Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2 12L37.0459 12.3405C37.0931 12.3604 37.132 12.3878 37.1589 12.4201C37.1858 12.4524 37.2 12.4886 37.2 12.5255C37.2 12.5623 37.1858 12.5985 37.1589 12.6309C37.132 12.6632 37.0931 12.6906 37.0459 12.7105L36.3675 13L36.2 12Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M35.462 15.0071C35.1798 14.9515 34.9149 14.7752 34.7 14.5C34.7 14.5 34.8153 15.5638 35.7 16.5L35.462 15.0071Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5519 14L32.4113 12.237C32.4113 12.237 31.3568 11.9471 31.8156 11.1845C32.2743 10.4218 32.9593 10.7669 33.2206 9.77523C33.242 9.59717 33.3233 9.42947 33.4533 9.29503C33.5834 9.1606 33.7559 9.06598 33.9472 9.0241C34.1386 8.98223 34.3395 8.99514 34.5225 9.06107C34.7055 9.127 34.8616 9.24274 34.9696 9.39248C35.3551 9.90571 36.7251 9.35188 36.6996 10.2624C36.6741 11.1729 35.3966 11.544 35.0334 11.6484C33.4436 12.1007 35.4284 13.6839 33.5519 14Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3981 17.0016C36.275 17.0958 31.2183 18.1695 26.5049 20.1639C25.7823 20.4675 25.13 20.9148 24.5883 21.4783C24.0466 22.0417 23.627 22.7092 23.3553 23.4398C23.0836 24.1703 22.9656 24.9483 23.0086 25.7259C23.0516 26.5034 23.2547 27.2639 23.6053 27.9606L31.716 44L46.741 43.1181C46.741 43.1181 49.475 34.1041 48.9275 23.9063C48.8169 22.0123 47.9705 20.2346 46.5664 18.9469C45.1622 17.6593 43.3096 16.962 41.3981 17.0016Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3699 43.8676L27 68H29.185L34.6638 54.8996C36.6047 50.2597 40.0256 46.3961 44.3909 43.9138L46 43L31.3699 43.8676Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 43L43.9114 68H41.2229C41.2229 68 41.8501 49.1956 37 45.184L46 43Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M28 20.5C28 20.5 34.4916 22.5929 33.2444 30.5668C32.8798 32.8978 33.0274 35.282 33.6767 37.5482C34.3261 39.8143 35.461 41.9061 37 43.6732L31.5536 44C31.5536 44 28.0601 36.6014 27.1308 35.0315C26.2015 33.4616 28 20.5 28 20.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 23.5999C31.0159 20.2804 26.9705 18.7496 24.8061 21.2171C22.9177 23.3162 21.714 25.9664 21.3623 28.7994C20.4997 36.088 21.4482 52 21.4482 52H24.02C24.02 52 25.7578 36.0978 29.5518 28.7994C30.6085 26.766 30.9936 25.036 31 23.5999Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 56.9109V55.6817C20 55.2357 20.1788 54.8079 20.4969 54.4926C20.8151 54.1772 21.2466 54 21.6966 54H23.3034C23.7534 54 24.1849 54.1772 24.5031 54.4926C24.8213 54.8079 25 55.2357 25 55.6817V57",
    stroke: "#003353",
    strokeWidth: 2.03,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 60H14V64H32V60Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M32 60H14V64H32V60Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8028 57L32 60H14L16.2005 57H29.8028Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2512 52C22.2512 52 21.5597 54.967 22.4712 54.967C23.3827 54.967 24.4714 55.5309 23.7828 52H22.2512Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8002 12.5134L37.13 10.0852C37.1713 10.0657 37.2059 10.0342 37.2291 9.99487C37.2524 9.9555 37.2634 9.91003 37.2605 9.86433C37.2577 9.81864 37.2413 9.77484 37.2133 9.73859C37.1854 9.70233 37.1472 9.6753 37.1038 9.661L36.8165 9.56846C36.4896 9.46755 36.2132 9.24556 36.0439 8.94776C35.574 8.14453 34.4277 6.58623 32.7415 7.01715C30.5858 7.56501 28.9684 9.79467 31.1301 12.3606C31.2098 12.456 31.3185 12.5226 31.4396 12.5502C31.5606 12.5778 31.6873 12.5649 31.8002 12.5134Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M31.0007 9.51521C30.9887 9.03845 31.1227 8.56615 31.392 8.13604C31.6613 7.70593 32.0584 7.32993 32.5517 7.03808C32.603 7.01134 32.6643 6.99806 32.7263 7.00023C32.7884 7.0024 32.8478 7.01992 32.8957 7.05014C32.9436 7.08035 32.9774 7.12165 32.992 7.1678C33.0066 7.21396 33.0012 7.26249 32.9766 7.3061C32.5335 8.00361 32.2874 8.76458 32.2542 9.53957C32.2495 9.65097 32.1938 9.75757 32.0967 9.84071C31.9996 9.92385 31.8673 9.97825 31.7231 9.99439C31.6331 10.005 31.5412 10.0005 31.4538 9.98124C31.3664 9.96196 31.2854 9.92836 31.2167 9.88275C31.148 9.83715 31.093 9.78065 31.0557 9.71718C31.0184 9.6537 30.9997 9.58478 31.0007 9.51521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9965 44C31.9965 44 33.7395 34.68 33.7395 29.5301C33.7395 21.918 31 18.6687 31 18.6687L32.1361 18.303C32.1361 18.303 34.5121 22.1988 38.4169 21.3694C42.0523 20.602 41.1304 17.0522 41.1142 17H42.1659C42.1659 17 45.5546 19.7888 46.3498 24.279C47.7001 31.8879 46.5283 42.5664 46.5283 42.5664L31.9965 44Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 43H30V45H46V43Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3454 42H30.6546C30.2931 42 30 42.2669 30 42.596V45.404C30 45.7331 30.2931 46 30.6546 46H32.3454C32.7069 46 33 45.7331 33 45.404V42.596C33 42.2669 32.7069 42 32.3454 42Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M32.3454 42H30.6546C30.2931 42 30 42.2774 30 42.6197V43.3803C30 43.7226 30.2931 44 30.6546 44H32.3454C32.7069 44 33 43.7226 33 43.3803V42.6197C33 42.2774 32.7069 42 32.3454 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 43C31.7761 43 32 42.7761 32 42.5C32 42.2239 31.7761 42 31.5 42C31.2239 42 31 42.2239 31 42.5C31 42.7761 31.2239 43 31.5 43Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3454 42H34.6546C34.2931 42 34 42.2669 34 42.596V45.404C34 45.7331 34.2931 46 34.6546 46H36.3454C36.7069 46 37 45.7331 37 45.404V42.596C37 42.2669 36.7069 42 36.3454 42Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M36.3454 42H34.6546C34.2931 42 34 42.2774 34 42.6197V43.3803C34 43.7226 34.2931 44 34.6546 44H36.3454C36.7069 44 37 43.7226 37 43.3803V42.6197C37 42.2774 36.7069 42 36.3454 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 43C35.7761 43 36 42.7761 36 42.5C36 42.2239 35.7761 42 35.5 42C35.2239 42 35 42.2239 35 42.5C35 42.7761 35.2239 43 35.5 43Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3454 42H44.6546C44.2931 42 44 42.2669 44 42.596V45.404C44 45.7331 44.2931 46 44.6546 46H46.3454C46.7069 46 47 45.7331 47 45.404V42.596C47 42.2669 46.7069 42 46.3454 42Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M46.3454 42H44.6546C44.2931 42 44 42.2774 44 42.6197V43.3803C44 43.7226 44.2931 44 44.6546 44H46.3454C46.7069 44 47 43.7226 47 43.3803V42.6197C47 42.2774 46.7069 42 46.3454 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 43C45.7761 43 46 42.7761 46 42.5C46 42.2239 45.7761 42 45.5 42C45.2239 42 45 42.2239 45 42.5C45 42.7761 45.2239 43 45.5 43Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45 30C45 30 38.2971 30.5035 36.2734 30L36 36.421C36 36.421 42.7437 37.5236 44.714 36.6856L45 30Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C15.8792 64 2 50.1208 2 33H0C0 51.2254 14.7746 66 33 66V64ZM64 33C64 50.1208 50.1208 64 33 64V66C51.2254 66 66 51.2254 66 33H64ZM33 2C50.1208 2 64 15.8792 64 33H66C66 14.7746 51.2254 0 33 0V2ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0Z",
    fill: "#E6EBEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_3247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1C50.6731 1 65 15.3269 65 33C65 50.6731 50.6731 65 33 65C15.3269 65 1 50.6731 1 33Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractors);
export default __webpack_public_path__ + "static/media/Contractors.cd6872ca14daf949b5c06dd7d4cfde13.svg";
export { ForwardRef as ReactComponent };